// extracted by mini-css-extract-plugin
export default {"root":"UncaughtErrorFallback_root__s3lUg","message":"UncaughtErrorFallback_message__kVrfe","error":"UncaughtErrorFallback_error__n4gMH"};